import { useCallback, useContext } from 'react';
import { UserContext } from '../../../../context';
import { Event, EventStatus } from '../../../../services';

export const useIsEventUnavailable = () => {
  const { channelId } = useContext(UserContext).userInfo.userData;

  return useCallback(
    (event: Event | null | undefined): boolean =>
      !event ||
      !event.channels.map(({ id }) => id).includes(channelId) ||
      event.status === EventStatus.UNPUBLISHED,
    [channelId]
  );
};
